import { requestWithAuth } from "./http";

const API_BASE = "https://api.touchprop.com/api/v1/tickets";
const FALLBACK_MESSAGE = "\u062e\u0637\u0627 \u062f\u0631 \u0627\u0631\u062a\u0628\u0627\u0637 \u0628\u0627 \u0633\u0631\u0648\u0631";

const request = (path, options = {}) =>
  requestWithAuth(`${API_BASE}${path}`, options, { fallbackMessage: FALLBACK_MESSAGE });

export function getTickets(status) {
  const query = status ? `?status=${encodeURIComponent(status)}` : "";
  return request(`/tickets/${query}`, { method: "GET" });
}

export function getTicketCategories() {
  return request("/ticket-categories/", { method: "GET" });
}

export function createTicket(payload) {
  return request("/tickets/create/", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function getTicket(id) {
  return request(`/tickets/${id}/`, { method: "GET" });
}

export function addTicketMessage(id, message) {
  return request(`/tickets/${id}/messages/`, {
    method: "POST",
    body: JSON.stringify({ message }),
  });
}
